'use client';

import { FC, useState } from 'react';
import { useFormStatus } from 'react-dom';

import { getOr } from 'src/utils/getOr';

import { Input } from './Input';
import { InputFormProps } from './Input.type';

/**
 * Input field expected to be used within a React Form
 */
export const InputForm: FC<InputFormProps<typeof Input>> = ({
  id,
  name,
  disabled,
  formState,
  defaultValue,
  ...props
}) => {
  const inputId = id ?? name;
  const error = getOr(formState, `errors.${name}[0]`, null);
  const { pending } = useFormStatus();
  const [value, setValue] = useState<string>(defaultValue ?? '');

  return (
    <Input
      {...props}
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
        if (props.onValueChange) props.onValueChange(e.target.value);
      }}
      id={inputId}
      name={name}
      error={error}
      disabled={disabled || pending}
    />
  );
};
